import { useSyncExternalStore } from "react";
import { getDataStore } from "@/data/dataStore.js";

export function notifyDataUpdate() {
  window.dispatchEvent(new Event("karate-data-updated"));
}

export function useDataStore() {
  return useSyncExternalStore(
    (cb) => {
      window.addEventListener("karate-data-updated", cb);
      return () => window.removeEventListener("karate-data-updated", cb);
    },
    () => getDataStore(),
    () => getDataStore(),
  );
}
